import { Accessor, UpdateParameters } from '@deck.gl/core';
import { Texture } from '@luma.gl/core';
import { positionTextureModule, positionTextureModuleName } from '../modules/coast-position-texture';
import { HidableScatterplotLayer } from './hidable-scatterplot-layer';

export class AnimatedScatterplotLayer<TData> extends HidableScatterplotLayer<
    TData,
    { positionTexture: Texture | null; getId: Accessor<TData, number> }
> {
    initializeState() {
        super.initializeState();
        const manager = this.getAttributeManager()!;
        manager.remove(['instancePositions']);
        manager.addInstanced({
            instanceId: {
                size: 1,
                type: 'uint32',
                accessor: 'getId'
            }
        });
    }

    updateState(params: UpdateParameters<this>): void {
        super.updateState(params);
        if (params.changeFlags.propsChanged) {
            this.state.model?.shaderInputs.setProps({
                [positionTextureModuleName]: this.props
            });
        }
    }

    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, positionTextureModule]
        };
    }
}
